import {
  CardIdentity,
  CardVitale,
  Localisation,
  SelfieIdentity,
} from '../../../../../../assets/icons';

/**
 * Configuration des types de documents pour les modaux de validation
 */
export const DOCUMENT_TYPES = {
  identity: {
    text: "Pièce d'identité",
    icon: (props = {}) => <CardIdentity wh={24} color={'#6B7280'} {...props} />,
  },
  selfie: {
    text: "Selfie d'identité",
    icon: (props = {}) => <SelfieIdentity wh={24} color={'#6B7280'} {...props} />,
  },
  visa: {
    text: 'Visa',
    icon: (props = {}) => <CardIdentity wh={24} color={'#6B7280'} {...props} />,
  },
  card_vitality: {
    text: 'Carte Vitale',
    icon: (props = {}) => <CardVitale wh={24} color={'#6B7280'} {...props} />,
  },
  proof_of_address: {
    text: 'Justificatif de domicile',
    icon: (props = {}) => <Localisation wh={24} color={'#6B7280'} {...props} />,
  },
  accommodation_of_address: {
    text: 'Attestation de logement',
    icon: (props = {}) => <Localisation wh={24} color={'#6B7280'} {...props} />,
  },
  hostIdentity: {
    text: "Pièce d'identité de l'hôte",
    icon: (props = {}) => <CardIdentity wh={24} color={'#6B7280'} {...props} />,
  },
};

/**
 * Récupère le libellé du type de document
 * @param {string} adminType - Le type de document
 * @param {object} tempWorker - Les données du tempWorker
 * @returns {string} Le libellé à afficher
 */
export const getDocumentLabel = (adminType, tempWorker) => {
  if (adminType === 'identity') {
    return tempWorker?.identity?.type === 'Passeport' ? 'Passeport' : "Carte d'identité";
  }
  if (adminType === 'visa') {
    return tempWorker?.visa?.type === 'Visa' ? 'Visa' : 'Titre de séjour';
  }
  return DOCUMENT_TYPES[adminType]?.text || adminType;
};

/**
 * Récupère la description du nombre de documents
 * @param {number} docsCount - Le nombre de documents
 * @returns {string} La description
 */
export const getDocumentCountLabel = (docsCount) => {
  if (docsCount === 2) return 'Recto & verso';
  if (docsCount > 2) return 'Plusieurs documents';
  return 'Document unique';
};
